import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogScrollableContent,
  DialogTitle,
} from "@win-reality/react-ui";

import { ThemedDialog } from "../ThemedDialog";

type DiscardChangesDialogProps = {
  isOpen: boolean;
  /** Back to the panel with the edits */
  onKeepEditing: () => void;
  /** Drops the edits and closes the panel */
  onDiscard: () => void;
};

/** Closing Manage Lineups with unsaved edits asks first. */
export const DiscardChangesDialog = ({
  isOpen,
  onKeepEditing,
  onDiscard,
}: DiscardChangesDialogProps) => (
  <ThemedDialog
    open={isOpen}
    onOpenChange={(open) => !open && onKeepEditing()}
    defaultCancelButton={false}
    size="md"
  >
    {({ showDivider, setScrollContainer }) => (
      <>
        <DialogScrollableContent setScrollContainer={setScrollContainer}>
          <DialogHeader>
            <DialogTitle className="text-gray-900 dark:text-white">
              Discard lineup changes?
            </DialogTitle>
          </DialogHeader>
          <p className="text-tagging-muted">
            Your lineup edits haven't been saved. Discard them and close?
          </p>
        </DialogScrollableContent>

        <DialogFooter showDivider={showDivider}>
          <div className="flex w-full justify-between">
            <Button
              variant="ghost"
              type="button"
              className="underline"
              onClick={onKeepEditing}
              data-testid="lineup-discard-dialog-cancel-button"
            >
              Keep Editing
            </Button>
            <Button
              variant="secondary-flat-light"
              onClick={onDiscard}
              data-testid="lineup-discard-dialog-confirm-button"
            >
              Discard
            </Button>
          </div>
        </DialogFooter>
      </>
    )}
  </ThemedDialog>
);
